const CONSTANTS = {
    // Homes
    ON_HOMES_ARE_LOADING: 'homes/ON_HOMES_ARE_LOADING',
    ON_HOMES_LIST: 'homes/ON_HOMES_LIST',
    // Administration
    ON_ADMIN_HOMES_ARE_LOADING: 'homes/ON_ADMIN_HOMES_ARE_LOADING',
    ON_ADMIN_HOMES_LIST: 'homes/ON_ADMIN_HOMES_LIST',
    ON_ADMIN_USERS_ARE_LOADING: 'homes/ON_ADMIN_USERS_ARE_LOADING',
    ON_ADMIN_USERS_LIST: 'homes/ON_ADMIN_USERS_LIST',
    ON_ADMIN_SEARCH_HOMES: 'homes/ON_ADMIN_SEARCH_HOMES',
    ON_ADMIN_SEARCH_USERS: 'homes/ON_ADMIN_SEARCH_USERS',
    // Tests
    ON_TEST_SMART_PI_CHANGE_SWITCHES: 'tests/ON_TEST_SMART_PI_CHANGE_SWITCHES',
    // Detail
    ON_HOME_DETAIL_IS_LOADING: 'homes/ON_HOME_DETAIL_IS_LOADING',
    ON_HOME_DETAIL_DATA: 'homes/ON_HOME_DETAIL_DATA',
    ON_HOME_USER_LIST_IS_LOADING: 'homes/ON_HOME_USER_LIST_IS_LOADING',
    ON_HOME_USER_LIST_DATA: 'homes/ON_HOME_USER_LIST_DATA',
    ON_HOME_ADD_OR_EDIT_MODAL_IS_SHOWN: 'homes/ON_HOME_ADD_OR_EDIT_MODAL_IS_SHOWN',
    ON_HOME_ADD_OR_EDIT_MODAL_IS_LOADING: 'homes/ON_HOME_ADD_OR_EDIT_MODAL_IS_LOADING',
    ON_HOME_ADD_OR_EDIT_MODAL_IS_EDIT: 'homes/ON_HOME_ADD_OR_EDIT_MODAL_IS_EDIT',
    ON_HOME_ADD_OR_EDIT_MODAL_SELECTED_ROW: 'homes/ON_HOME_ADD_OR_EDIT_MODAL_SELECTED_ROW',
    ON_HOME_INVITE_RESIDENT_MODAL_IS_SHOWN: 'homes/ON_HOME_INVITE_RESIDENT_MODAL_IS_SHOWN',
    ON_HOME_INVITE_RESIDENT_MODAL_IS_LOADING: 'homes/ON_HOME_INVITE_RESIDENT_MODAL_IS_LOADING',
    ON_HOME_DETAIL_INVITED_USERS_LIST: 'homes/ON_HOME_DETAIL_INVITED_USERS_LIST',
    ON_HOME_DETAIL_INVITED_USERS_IS_LOADING: 'homes/ON_HOME_DETAIL_INVITED_USERS_IS_LOADING',
    ON_HOME_DETAIL_METERS_IS_LOADING: 'homes/ON_HOME_DETAIL_METERS_IS_LOADING',
    ON_HOME_DETAIL_METERS_DATA: 'homes/ON_HOME_DETAIL_METERS_DATA',
    ON_HOME_DETAIL_METER_DEVICE_IS_LOADING: 'homes/ON_HOME_DETAIL_METER_DEVICE_IS_LOADING',
    ON_HOME_DETAIL_METER_DEVICE_DATA: 'homes/ON_HOME_DETAIL_METER_DEVICE_DATA',
    ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_SHOWN:
        'homes/ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_SHOWN',
    ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_LOADING:
        'homes/ON_HOME_DETAIL_METERS_ADD_OR_EDIT_MODAL_IS_LOADING',
    ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_SHOWN:
        'homes/ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_SHOWN',
    ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_LOADING:
        'homes/ON_HOME_DETAIL_SWITCH_ADD_OR_EDIT_MODAL_IS_LOADING',
    ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_SHOWN:
        'homes/ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_SHOWN',
    ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_LOADING:
        'homes/ON_HOME_DETAIL_ADD_OR_EDIT_DEVICE_MODAL_IS_LOADING',
    // Owners
    ON_OWNER_LIST_IS_LOADING: 'homes/ON_OWNER_LIST_IS_LOADING',
    ON_OWNER_LIST_DATA: 'homes/ON_OWNER_LIST_DATA'
};

export { CONSTANTS };
